import '@hawtio/react/dist/init.css'
import '@hawtio/react/dist/index.css'
import '@patternfly/react-core/dist/styles/base.css'
import './index.css'

import('./bootstrap')

export {}
